import { Dropdown, Tooltip } from 'bootstrap'
import ClipboardJS from '../../../node_modules/clipboard/src/clipboard'

export const dashboard = () => {
  // Use setInterval to check for dashboard every 100ms, stop when found or after 5s
  const checkForDashboard = () => {
    const dashboard = document.querySelector('[class^="en__p2p__dashboard"]')

    if (dashboard) {
      clearInterval(interval)
      document.documentElement.classList.add('p2p-dashboard')
      setTimeout(() => {
        initDashboard()
      }, 600)
    }
  }

  let interval = setInterval(checkForDashboard, 100)

  // After 5 seconds, clear the interval.
  setTimeout(() => {
    clearInterval(interval)
  }, 5000)
}

const initDashboard = () => {
  //handleNav()
  makeDropdownNav()
  generic()
  myPage()
  socialMedia()
  rewards()
}

const handleNav = () => {
  const nav = document.querySelector('.en__dashboard__nav')

  if (nav) {
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('mouseup', (e) => {
        setTimeout(() => {
          initDashboard()
        }, 800)
      })
    })
  }
}

const makeDropdownNav = () => {
  // transforms the dashboard nav into a bootstrap dropdown for mobile
  // done to add icons to the links since the OOB nav is not editable
  const dashboardNav = document.querySelector('.en__dashboard__nav')

  if (dashboardNav) {
    const menu = dashboardNav.querySelector('ol')
    const activeLink = dashboardNav.querySelector('.router-link-exact-active')

    dashboardNav.classList.add('dropdown')

    if (menu) {
      menu.classList.add('dropdown-menu')
      menu.querySelectorAll('a').forEach((item) => {
        item.classList.add('dropdown-item')
      })
    }

    if (activeLink) {
      const dropdownToggle = document.createElement('button')
      const activeLinkPage = activeLink.getAttribute('href').split('/').pop() || 'my-page'

      dropdownToggle.classList.add('dropdown-toggle', activeLinkPage)
      dropdownToggle.dataset.bsToggle = 'dropdown'
      dropdownToggle.setAttribute('aria-expanded', 'false')
      dropdownToggle.setAttribute('type', 'button')
      dropdownToggle.innerHTML = activeLink.innerHTML
      dashboardNav.prepend(dropdownToggle)
      new Dropdown(dropdownToggle)
    }
  }
}

const generic = () => {
  const formLabels = document.querySelectorAll('.p2p-dashboard .en__formField__label')
  formLabels.forEach((label) => label.classList.add('form-label'))
  const inputs = document.querySelectorAll('.p2p-dashboard input')
  inputs.forEach((input) => input.classList.add('form-control', 'form-control-sm'))
  const selects = document.querySelectorAll('.p2p-dashboard select')
  selects.forEach((select) => select.classList.add('form-select', 'form-select-sm'))
}

const myPage = () => {
  const isMyPage = document.querySelector('[class^="en__p2p__dashboard__myPage"]')

  const getPageUrl = () => {
    const individualFundraisingPage = enParticipantJson?.participants[0]?.pages?.filter((page) => page.type === 'IND')

    if (Array.isArray(individualFundraisingPage)) {
      return individualFundraisingPage[0].url
    }
  }

  const getTeamPageUrl = () => {
    const teamPage = enParticipantJson?.participants[0]?.pages?.filter((page) => page.type === 'TEAM')

    if (Array.isArray(teamPage)) {
      return teamPage[0].url
    }
  }

  const makeFundraisingPageLink = () => {
    const copyToClipboard = (wrapper) => {
      const copyToClipboardButton = document.createElement('button')

      copyToClipboardButton.classList.add('btn-copy')
      copyToClipboardButton.setAttribute('aria-label', 'Copy to clipboard')
      copyToClipboardButton.setAttribute('type', 'button')
      copyToClipboardButton.dataset.clipboardTarget = '#p2pSharableUrl'

      // add a Bootstrap tooltip to the button to show when clicked
      copyToClipboardButton.dataset.bsToggle = 'tooltip'
      copyToClipboardButton.dataset.bsPlacement = 'bottom'
      copyToClipboardButton.dataset.bsTrigger = 'manual'
      copyToClipboardButton.title = 'Copied to clipboard!'

      // add the button to the link sub wrapper
      wrapper.appendChild(copyToClipboardButton)

      // initialize the tooltip and clipboard
      const tooltip = Tooltip.getOrCreateInstance(copyToClipboardButton)
      const clipboard = new ClipboardJS(copyToClipboardButton)

      clipboard.on('success', function (e) {
        // show the tooltip
        tooltip.show()

        setTimeout(() => {
          // hide the tooltip
          tooltip.hide()
        }, 2000)
      })
    }

    const makeSharableLink = (pageUrl) => {
      const titleSection = document.querySelector('.en__p2p__dashboard__myPage__pfp__title')
      const linkWrapper = document.createElement('div')
      const linkHeading = document.createElement('div')
      const linkSubWrapper = document.createElement('div')
      const link = document.createElement('input')

      linkWrapper.classList.add('en__formField', 'en__formField--text', 'en__field--p2pSharableUrl')

      linkHeading.classList.add('en__formField__label')
      linkHeading.classList.add('form-label')
      linkHeading.setAttribute('role', 'heading')
      linkHeading.textContent = 'Sharable URL'

      linkSubWrapper.classList.add('en__input', 'en__input--text', 'en__formField__field')

      link.setAttribute('id', 'p2pSharableUrl')
      link.setAttribute('type', 'text')
      link.setAttribute('value', pageUrl)
      link.setAttribute('readonly', '')
      link.textContent = pageUrl

      linkSubWrapper.appendChild(link)

      linkWrapper.appendChild(linkHeading)
      linkWrapper.appendChild(linkSubWrapper)

      titleSection.appendChild(linkWrapper)

      // add a copy to clipboard button
      copyToClipboard(linkSubWrapper)
    }

    const pageUrl = getPageUrl()

    if (pageUrl) {
      makeSharableLink(pageUrl)
    }
  }

  const handlePreviewPageButton = () => {
    const previewPageButton = document.querySelector('.en__p2p__button:last-of-type:not(:first-of-type)')
    const isTeamPage = document.querySelector('.router-link-active[href="#/team"]') ? true : false

    if (previewPageButton) {
      const pageUrl = isTeamPage ? getTeamPageUrl() : getPageUrl()

      previewPageButton.setAttribute('type', 'button')

      if (pageUrl) {
        previewPageButton.addEventListener('click', (e) => {
          const handle = window.open(pageUrl, 'previewWindow', 'popup')

          if (!handle) {
            alert('Please allow popups for this site')
          }
        })
      }
    }
  }

  if (isMyPage) {
    setTimeout(() => {
      makeFundraisingPageLink()
      handlePreviewPageButton()
    }, 1000)
  }
}

const socialMedia = () => {
  const isSocialMedia = document.querySelector('.en__p2p__dashboard__social')

  if (!isSocialMedia) return

  const headings = () => {
    document.querySelectorAll('.en__p2p__dashboard__socialShare h3').forEach((heading) => {
      // get the text in parenthesis and wrap it in a span
      const text = heading.textContent
      const textInParenthesis = text.match(/\(([^)]+)\)/)[0]
      const textInParenthesisSpan = document.createElement('span')

      textInParenthesisSpan.classList.add('text-black')
      textInParenthesisSpan.textContent = textInParenthesis

      // remove the text in parenthesis from the heading
      heading.textContent = text.replace(textInParenthesis, '')

      // add the span to the heading
      heading.appendChild(textInParenthesisSpan)
    })
  }

  const handleCopyButton = () => {
    const copyButtons = document.querySelectorAll('.en__p2p__copyText__field button')

    copyButtons.forEach((button) => {
      button.setAttribute('aria-label', 'Copy to clipboard')
      button.setAttribute('title', 'Copy to clipboard')
    })
  }

  headings()
  handleCopyButton()
}

const rewards = () => {
  const isRewards = document.querySelector('.en__p2p__dashboard__incentiveRewards')
  if (!isRewards || document.querySelector('.incentive-group')) return

  const parentContainer = document.querySelector('.en__p2p__dashboard__incentiveRewards__container')
  const incentiveGroups = document.querySelectorAll('.en__p2p__dashboard__incentiveReward')

  incentiveGroups.forEach((group, i) => {
    const firstProduct = group.querySelector('.en__p2p__dashboard__incentiveReward__product')
    const enRewardBar = firstProduct.querySelector('.en__p2p__dashboard__incentiveReward__bar')
    const currentTotal = enRewardBar.getAttribute('data-en-incentive-total')
    const threshold = enRewardBar.getAttribute('data-en-incentive-current')
    const percentComplete = (parseFloat(currentTotal.replace('$', '')) / parseFloat(threshold.replace('$', ''))) * 100

    const h4 = document.createElement('h4')
    h4.textContent = `Raise ${threshold} to earn these rewards!`
    h4.classList.add('incentive-group-title')
    const groupDiv = document.createElement('div')
    groupDiv.classList.add('incentive-group')
    groupDiv.appendChild(h4)
    groupDiv.appendChild(group)

    if (group.childElementCount > 1) {
      const p = document.createElement('p')
      p.textContent = 'Choose one gift from this level.'
      p.classList.add('incentive-group-subtitle')
      groupDiv.appendChild(p)
    }

    parentContainer.appendChild(groupDiv)
  })
}
